
import * as shared from '../../shared'

export default function Form({ containerClass = "", containerProps = [], children, ...props }) {



  // const style = {
  //   margin: "auto",
  //   width: '400px',
  //   color: shared.baseColor,
  //   background: shared.baseColor,
  // }

  // const containerStyle = {
  //   margin: 20,
  //   display: 'flex',
  //   justifyContent: 'center',
  //   flexDirection: 'column',
  //   gap: '20px'
  // }


  return (
    <div className={"form_wrapper" + " " + containerClass}>
      <form {...props} className={'form' + " " + props.className || ''}>
        {/* <div style={containerStyle} {...containerProps}> */}
          {children}
        {/* </div> */}
      </form>
    </div>
  );
}
